import {
  APEX_CLASS,
  APEX_TRIGGER,
  APPROVAL_PROCESS,
  FIELD,
  FLOW,
  OBJECT,
  LAYOUT,
  RECORD_TYPE,
  PROCESS_BUILDER_FLOW,
  VALIDATION_RULE,
  WORKFLOW_RULE,
} from '@server/parser';
import { ConfigurationToName } from '../dependencies/types';

export const configurationTypesOptions = [
  {
    value: APEX_CLASS,
    label: ConfigurationToName[APEX_CLASS],
  },
  {
    value: APEX_TRIGGER,
    label: ConfigurationToName[APEX_TRIGGER],
  },
  {
    value: APPROVAL_PROCESS,
    label: ConfigurationToName[APPROVAL_PROCESS],
  },
  { value: FIELD, label: ConfigurationToName[FIELD] },
  { value: FLOW, label: ConfigurationToName[FLOW] },
  {
    value: OBJECT,
    label: ConfigurationToName[OBJECT],
  },
  { value: LAYOUT, label: ConfigurationToName[LAYOUT] },
  {
    value: RECORD_TYPE,
    label: ConfigurationToName[RECORD_TYPE],
  },
  {
    value: PROCESS_BUILDER_FLOW,
    label: ConfigurationToName[PROCESS_BUILDER_FLOW],
  },
  {
    value: VALIDATION_RULE,
    label: ConfigurationToName[VALIDATION_RULE],
  },
  {
    value: WORKFLOW_RULE,
    label: ConfigurationToName[WORKFLOW_RULE],
  },
];

//regexp adding space between lowerCase and capital letters
export const formatCamelCase = (text: string) => text.replace(/([a-z])([A-Z])/g, '$1 $2');
